module.exports = __webpack_public_path__ + "static/media/0.7e2008de.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/0.png
// module id = 1218
// module chunks = 0